module.exports = __webpack_public_path__ + "static/img/xitai.82ab42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xitai.png
// module id = exU1
// module chunks = 1